export function JsonIsNull(par) {
    for (var item in par) {
        return true
    }
    return false;
}

export function GetTime(starttime, endtime) {
    var date3 = endtime - starttime;
    var days = Math.floor(date3 / (24 * 3600 * 1000))
    var leave1 = date3 % (24 * 3600 * 1000)
    var hours = Math.floor(leave1 / (3600 * 1000))
    var leave2 = leave1 % (3600 * 1000)
    var minutes = Math.floor(leave2 / (60 * 1000))
    var leave3 = leave2 % (60 * 1000)
    var seconds = Math.round(leave3 / 1000)
    return days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60 + seconds
}


// WEBPACK FOOTER //
// ./src/utils/JsonIsNull.js